import { Select } from "@circleco/compass/components/Select";
import { useMemo } from "react";

import { t } from "@/i18n-js/instance";
import type { Agent } from "@/react/types/CommunityBot/ChatSort";

interface AgentDropdownComponentProps {
  activeItem: Agent;
  dataTestId?: string;
  items: Agent[];
  onItemClick: (item: Agent) => void;
}

export const AgentDropdownComponent = ({
  activeItem,
  dataTestId,
  items,
  onItemClick,
}: AgentDropdownComponentProps) => {
  const options = useMemo(
    () =>
      items.map((item: Agent) => ({
        value: item.id,
        label: item.name,
      })),
    [items],
  );

  const selectedOption = useMemo(
    () => options.find(opt => opt.value === activeItem.id) ?? null,
    [options, activeItem.id],
  );

  return (
    <Select<number>
      options={options}
      value={selectedOption}
      onValueChange={opt => {
        const agent = items.find(item => item.id === opt?.value);
        if (agent) {
          onItemClick(agent);
        }
      }}
      aria-label={t("community_inbox.filters.select_agent")}
      align="start"
      side="bottom"
      data-testid={dataTestId}
    />
  );
};
